var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrianglePinYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 83 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5115 1.5C39.6662 -0.5 42.553 -0.5 43.7077 1.5L62.7602 34.5L81.8128 67.5C82.9675 69.5 81.5241 72 79.2147 72H41.1096H3.00448C0.695075 72 -0.748301 69.5 0.406399 67.5L19.459 34.5L38.5115 1.5Z",
    fill: "#E8B749"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrianglePinYellow);
export default __webpack_public_path__ + "static/media/trianglePinYellow.737a93c50b06f10120f846d4c4944186.svg";
export { ForwardRef as ReactComponent };